import React, { useEffect, useState } from 'react';
import { MdHistory } from "react-icons/md";
import { getSellerTransactionsApi } from "../../ApiCalls/Revenue";

const SellerTransactionHistory = () => {
    const [transactions, setTransactions] = useState([]);
    const [pagination, setPagination] = useState({ page: 1, total_pages: 1, total_records: 0 });
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        const fetchTransactions = async () => {
            setLoading(true);
            try {
                const res = await getSellerTransactionsApi(currentPage, 20);
                if (res?.status === 1) {
                    setTransactions(res.data || []); 
                    setPagination(res.pagination);   
                }
            } catch (error) {
                console.error("Failed to fetch transactions", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTransactions();
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.total_pages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="p-6 space-y-8 min-h-screen">
            <div className="flex items-center space-x-2 mb-6">
                <MdHistory className="text-3xl text-gray-700" />
                <h1 className="text-2xl font-bold text-gray-800">Transaction History</h1>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50">
                    <h2 className="text-lg font-bold text-gray-800">All Transactions</h2>
                </div>
                
                <div className="overflow-x-auto">
                    <table className="min-w-full text-left text-sm whitespace-nowrap">
                        <thead className="bg-gray-100 text-gray-600 uppercase text-xs font-bold leading-normal">
                            <tr>
                                <th className="px-6 py-3">Date</th>
                                <th className="px-6 py-3">Reference ID</th>
                                <th className="px-6 py-3">Description</th>
                                <th className="px-6 py-3">Status</th>
                                <th className="px-6 py-3 text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 text-sm font-light">
                            {loading ? (
                                <tr>
                                    <td colSpan="5" className="px-6 py-10 text-center text-gray-400">Loading transactions...</td>
                                </tr>
                            ) : transactions.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="px-6 py-10 text-center text-gray-400">No transactions found.</td>
                                </tr>
                            ) : (
                                transactions.map((txn, index) => (
                                    <tr key={txn.id || index} className="border-b border-gray-200 hover:bg-gray-50">
                                        <td className="px-6 py-3">
                                            {new Date(txn.created_at).toLocaleDateString()}
                                        </td>
                                        <td className="px-6 py-3 font-mono text-xs">{txn.reference_id || 'N/A'}</td>
                                        <td className="px-6 py-3 font-medium">{txn.remarks || 'No description'}</td>
                                        <td className="px-6 py-3">
                                            <span className={`px-2 py-1 rounded text-xs uppercase font-semibold ${
                                                txn.status === 'SUCCESS' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                                            }`}>
                                                {txn.status}
                                            </span>
                                        </td>
                                        <td className={`px-6 py-3 text-right font-bold ${txn.amount >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                            {txn.amount >= 0 ? '+' : ''}₹{Math.abs(txn.amount).toLocaleString()}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-between items-center text-sm text-gray-600">
                    <div>
                        Showing Page {pagination.page} of {pagination.total_pages} ({pagination.total_records} records)
                    </div>
                    <div className="flex gap-2">
                        <button 
                            className="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-50"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1 || loading}
                        >
                            Previous
                        </button>
                        <button 
                            className="px-3 py-1 border rounded bg-white hover:bg-gray-100 disabled:opacity-50"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === pagination.total_pages || loading}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SellerTransactionHistory;